namespace TabAurous.Administration {
    export interface CampaignTemplatesRow {
        Id?: number;
        TemplateTypeId?: number;
        TemplateType?: string;
        ProviderTypeId?: number;
        ProviderType?: string;
        Code?: string;
        Title?: string;
        Message?: string;
        Html?: string;
        Image?: string;
        Footer?: string;
        Url?: string;
    }

    export namespace CampaignTemplatesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'Administration.CampaignTemplates';
        export const lookupKey = 'CTEMPR';

        export function getLookup(): Q.Lookup<CampaignTemplatesRow> {
            return Q.getLookup<CampaignTemplatesRow>('CTEMPR');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            TemplateTypeId = "TemplateTypeId",
            TemplateType = "TemplateType",
            ProviderTypeId = "ProviderTypeId",
            ProviderType = "ProviderType",
            Code = "Code",
            Title = "Title",
            Message = "Message",
            Html = "Html",
            Image = "Image",
            Footer = "Footer",
            Url = "Url"
        }
    }
}
